import Skeleton from '@material-ui/lab/Skeleton';
import DashboardLayout from 'components/DashboardLayout';
import NotificationsBloc from 'components/NotificationsBloc';
import Faq from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions';
import { StyledShortBody } from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions/styles';
import WelcomeHeader from 'containers/AUTODashboard/Header/WelcomeHeader';
import ActionsButton from 'containers/EpargnDashboard/ActionButtons';
import MyContracts from 'containers/EpargnDashboard/Body/MyContracts';
import SituationEpargn from 'containers/EpargnDashboard/Body/SituationEpargn';
import GATracking, { EVENT_ACTION, EVENT_CATEGORIES } from 'helpers/GATracking';
import { isReverse } from 'helpers/intl';
import HeaderEpargn from 'images/Header_Epargn.png';
import { sanlamDarkBlue } from 'Material-UI/colors';
import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getContractsEpargn } from 'store/contract/actions';
import {
  getContractsEpargnSelector,
  getIsLoadingContractEpargnSelector,
  getSituationEpargne,
} from 'store/contract/selectors';
import {
  getFaq,
  getLastNotification,
  setEpargnDetailsPageBreadcrumbsPath,
  setNotificationRead,
} from 'store/global/actions';
import {
  getEpargnFaqSelector,
  getLastNotificationEpargnSelector,
} from 'store/global/selectors';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { getFirstNameSelector } from 'store/user/selectors';
import { PRIVILEGES } from 'utils/globalConst';

const EpargnDashboard = (props: EpargnDashboardType) => {
  /* eslint-disable */
  const { EPARGN } = PRIVILEGES;
  const language = useSelector(getLocaleSelector);
  const reverse = isReverse(language);
  useEffect(() => {
    props.getLastNotification(EPARGN);
  }, [EPARGN, props.getLastNotification]);
  /* eslint-enable */
  /* eslint-disable */
  useEffect(() => {
    props.getContractsEpargn();
  }, [props.getContractsEpargn]);
  /* eslint-enable */
  useEffect(() => {
    props.getFaq(language);
    // eslint-disable-next-line
  }, [language]);
  return (
    <>
      <DashboardLayout
        Faq={
          <Faq
            items={
              props.faqEpargn &&
              props.faqEpargn.map(
                (
                  item: { question: string; code: string; id: number },
                  index: number,
                ) => ({
                  title: (
                    <StyledShortBody
                      weight="bold"
                      color={sanlamDarkBlue}
                      key={index}
                    >
                      {item.question}
                    </StyledShortBody>
                  ),
                  path: '/faq',
                  id: item.id,
                  code: item.code,
                  isFaq: true,
                  category: EVENT_CATEGORIES.EPARGN_ACCUEIL,
                  label: item.question,
                }),
              )
            }
            GACategoryAllResponses={EVENT_CATEGORIES.EPARGN_ACCUEIL}
          />
        }
        MyContracts={
          props.isLoadingContractEpargn ? (
            (GATracking.event(
              EVENT_CATEGORIES.EPARGN_ACCUEIL,
              EVENT_ACTION.LOAD,
              'Header Epargne_BOUTON  Epargne',
            ),
            (
              <Skeleton
                data-testid="loader"
                variant="rect"
                width={376}
                height={164}
              />
            ))
          ) : (
            <MyContracts
              contractsEpargn={props.contractsEpargn}
              setDetailsPageBreadcrumbsPath={
                props.setEpargnDetailsPageBreadcrumbsPath
              }
            />
          )
        }
        LastSinistre={
          props.isLoadingContractEpargn ? (
            (GATracking.event(
              EVENT_CATEGORIES.EPARGN_ACCUEIL,
              EVENT_ACTION.LOAD,
              'Header Epargne_BOUTON  Epargne',
            ),
            (
              <Skeleton
                data-testid="loader"
                variant="rect"
                width={376}
                height={164}
              />
            ))
          ) : (
            <SituationEpargn
              setDetailsPageBreadcrumbsPath={
                props.setEpargnDetailsPageBreadcrumbsPath
              }
              contractsEpargn={props.contractsEpargn}
            />
          )
        }
        WelcomeHeader={<WelcomeHeader name={props.firstName} />}
        HeaderImage={HeaderEpargn}
        MenuItem={
          <ActionsButton
            setDetailsPageBreadcrumbsPath={
              props.setEpargnDetailsPageBreadcrumbsPath
            }
          />
        }
        NotificationsBloc={
          <NotificationsBloc
            message={
              props.lastNotificationEPARGN?.message &&
              props.lastNotificationEPARGN.message
            }
            ignoreNotify={() =>
              props.setNotificationRead({
                id: props.lastNotificationEPARGN.id,
                section: EPARGN,
                isRedirectTo: false,
              })
            }
            clickEvent={() =>
              props.setNotificationRead({
                id: props.lastNotificationEPARGN.id,
                section: EPARGN,
              })
            }
          />
        }
      />
    </>
  );
};

export type EpargnDashboardType = {
  getLastNotification: Function;
  intl: IntlShape;
  firstName: string;
  getContractsEpargn: Function;
  setEpargnDetailsPageBreadcrumbsPath: Function;
  isLoadingContractEpargn: boolean;
  contractsEpargn: any[];
  situationEpargn: any[];
  lastNotificationEPARGN: {
    type: string;
    id: Number;
    idApp: string;
    action_title: string;
    message: string;
    title: string;
    policyNumber: string;
    status: string;
    read: boolean;
  };
  setNotificationRead: Function;
  getFaq: Function;
  faqEpargn: any[];
};

const mapDispatchToProps = {
  getContractsEpargn,
  getLastNotification,
  setEpargnDetailsPageBreadcrumbsPath,
  setNotificationRead,
  getFaq,
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    firstName: string;
    contractsEpargn: any;
    situationEpargn: any;
    lastNotificationEPARGN: any;
    faqEpargn: [];
    isLoadingContractEpargn: boolean;
  }
>({
  firstName: getFirstNameSelector,
  contractsEpargn: getContractsEpargnSelector,
  situationEpargn: getSituationEpargne,
  lastNotificationEPARGN: getLastNotificationEpargnSelector,
  faqEpargn: getEpargnFaqSelector,
  isLoadingContractEpargn: getIsLoadingContractEpargnSelector,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(EpargnDashboard));
export { EpargnDashboard };
